module.exports = __webpack_public_path__ + "img/drafts.58b889a8.svg";